import { Component, OnInit, Input } from '@angular/core';
import { HelperService } from '../../../../utils/helper.service';
@Component({
  templateUrl: './date-created.component.html',
  styleUrls: ['./date-created.component.scss']
})
export class DateCreatedComponent implements OnInit {
  @Input() value: any;
  dateValue: string;
  getUserCountry: string;

  constructor(private helperService: HelperService) { }

  ngOnInit() {
    if (this.value) {
      this.dateValue = this.helperService.transformDate(this.value);
    }
  }
}
